<template>
  <div class="address-manage">
    <h3>地址管理</h3>
    <p class="p">共<span>{{ this.list.length }}</span>个地址,最多保存20个</p>
    <table>
      <thead>
      <tr>
        <th class="address-name">收件人姓名</th>
        <th class="phone">电话号码</th>
        <th class="address">地址</th>
        <th class="operation">操作</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in list" :key="index">
        <td class="username">{{ item.username }}</td>
        <td class="phone">{{ item.phone }}</td>
        <td class="address">{{ item.province_name }} {{ item.city_name }} {{ item.district_name }} {{
            item.address
          }}
        </td>
        <td class="defalut" v-if="item.status == 1">默认地址</td>
        <td class="btns">
          <span class="change" @click="changeAddress(item.id,item)">修改</span>
          <el-button type="text" @click="open(item.id)">删除</el-button>
        </td>
      </tr>
      </tbody>
    </table>
    <p class="add-address">
      <span @click="addAddress()">+新增地址</span>（最多添加20个）
    </p>
    <addAddress class="dialog-box" @updateData="getList" v-if="flag" :flag="this.flag" @flag="disappear" :id="this.id"
                :itemCityData="this.itemCityData" :itemData="this.itemData"
                :changeState="this.changeState"></addAddress>
  </div>
</template>

<script>
import addAddress from './addAddress'

export default {
  data() {
    return {
      list: [],
      flag: false,
      id: '',
      changeState: false,
      itemData: [],
      itemCityData: []
    };
  },
  components: {
    addAddress,
  },
  methods: {
    open(id) {
      this.$confirm('您确定要删除吗', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.closeAll()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.remove(id)
      }).catch(() => {
      });
    },
    changeAddress(id, item) {
      console.log(id, item)
      this.id = id
      this.$api.address.detailAddress({
        id: id
      }).then(res => {
        console.log(res)
        this.flag = true
        this.changeState = true
        this.itemData = res.data
        this.itemCityData = item
      })
    },
    addAddress() {
      this.flag = true
      this.changeState = false
    },
    remove(id) {
      this.$api.address.delete({
        id: id
      }).then(res => {
        this.getList()
        if (res.status == 1) {
          this.$message.closeAll()
          this.$message.success('删除成功');
        }
      })
    },
    disappear(params) {
      this.flag = params
    },
    getList() {
      this.$api.address.addressList({}).then((res) => {
        this.list = res.data
      });
    }
  },
  created() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.address-manage {
  position: relative;
}

* {
  font-size: 15px;
}

.dialog-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

h3 {
  font-size: 24px;
  color: #333333;
}

.p {
  font-size: 12px;
  color: #999999;
  letter-spacing: 1px;
  margin-top: 40px;
}

table {
  margin-top: 16px;
}

thead {
  width: 876px;
  height: 54px;
  background: #f5f5f5;
  display: flex;

  tr {
    width: 876px;
    height: 54px;
    display: flex;

    th {
      line-height: 64px;
      font-size: 16px;
      color: #333333;

      &.address-name {
        margin-left: 21px;
      }

      &.phone {
        margin-left: 82px;
      }

      &.address {
        margin-left: 123px;
      }

      &.operation {
        margin-left: 345px;
      }
    }
  }
}

tbody {
  width: 876px;

  tr {
    display: flex;
    width: 876px;
    height: 50px;
    border: 1px solid #dddddd;
    border-top: none;
    line-height: 50px;
    font-size: 12px;
    color: #333333;
    position: relative;

    .username {
      width: 100px;
      margin-left: 21px;
    }

    .phone {
      width: 78px;
      margin-left: 42px;
    }

    .address {
      width: 299px;
      margin-left: 53px;
    }

    .defalut {
      min-width: 66px;
      height: 22px;
      background: #fff4d9;
      border: 1px solid #A52A2A;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      color: #A52A2A;
      line-height: 22px;
      margin-top: 14px;
    }

    .btns {
      position: absolute;
      left: 700px;
      font-size: 12px;
      color: #A52A2A;
      cursor: pointer;

      .el-button--text {
        font-size: 12px;
        color: #A52A2A;
        margin-left: 10px;
      }
    }
  }
}

.add-address {
  width: 100%;
  height: 500px;
  font-size: 16px;
  color: #ccc;
  letter-spacing: 1px;
  margin-top: 17px;

  span {
    cursor: pointer;
    color: #A52A2A;
  }
}
</style>
